<template>
    <GDialog
        v-model="modalStore.activeRoutePointModal.show"
        max-width="500"
        border-radius="10"
        @update:model-value="hideModal"
    >
        <div class="active-route-point-modal">
            <div class="container">
                <div class="modal-header">
                    <div class="modal-title">
                        <div
                            class="route-status"
                            :style="{ background: pointData?.status?.color }"
                        ></div>
                        <div class="text-h4 text-bold">{{ pointAddress }}</div>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="route-point-body">
                        <template v-if="sortedItems.length">
                            <ActiveRouteTask
                                v-for="(task, key) in sortedItems"
                                :key="key"
                                :task-data="task"
                            />
                        </template>
                        <template v-else>
                            <div class="no-tasks text-h4 text-grey">
                                У вас немає завдань на цій точці
                            </div>
                        </template>

                        <ButtonComponent
                            v-if="
                                pointData &&
                                pointData.status.value !== 'Completed' &&
                                firstUncompleted
                            "
                            btn-style="gradient"
                            text="Позначити точку виконаною"
                            @click="completePoint"
                        />
                        <ButtonComponent
                            v-if="
                                pointData &&
                                pointData.status.value !== 'Uncompleted' &&
                                lastCompleted
                            "
                            btn-style="grey"
                            text="Позначити точку невиконаною"
                            @click="uncompletePoint"
                        />
                    </div>
                </div>

                <div class="modal-buttons">
                    <div class="container">
                        <ButtonComponent
                            class="back-btn"
                            btn-style="grey"
                            text="Повернутись назад"
                            @click="hideModal"
                        />
                    </div>
                </div>
            </div>
        </div>
    </GDialog>
</template>

<script>
import ActiveRouteTask from '@/components/activeRoute/ActiveRouteTask.vue'
import ButtonComponent from '@/components/ButtonComponent.vue'
import { useActiveRouteStore, useModalStore } from '@/stores/index.js'

export default {
    name: 'ActiveRoutePointModal',
    components: { ButtonComponent, ActiveRouteTask },
    setup() {
        const activeRouteStore = useActiveRouteStore()
        const modalStore = useModalStore()

        return { activeRouteStore, modalStore }
    },
    computed: {
        pointData() {
            return this.modalStore.activeRoutePointModal.pointData
        },

        sortedItems() {
            if (!this.pointData?.items) return []

            return [...this.pointData.items].sort((a, b) => {
                const aCompleted = a.action_status.value === 'Completed'
                const bCompleted = b.action_status.value === 'Completed'

                if (aCompleted === bCompleted) return 0

                return aCompleted ? 1 : -1
            })
        },

        firstUncompleted() {
            return this.modalStore.activeRoutePointModal.firstUncompleted
        },

        lastCompleted() {
            return this.modalStore.activeRoutePointModal.lastCompleted
        },

        pointAddress() {
            return this.pointData?.address || 'Точка маршруту'
        }
    },
    methods: {
        completePoint() {
            if (!this.pointData) return
            this.activeRouteStore.updatePointStatus(this.pointData.id, 'Completed')
        },

        uncompletePoint() {
            if (!this.pointData) return
            this.activeRouteStore.updatePointStatus(this.pointData.id, 'Uncompleted')
        },

        hideModal() {
            this.modalStore.activeRoutePointModal.show = false
            this.modalStore.activeRoutePointModal.pointData = null
            this.modalStore.activeRoutePointModal.firstUncompleted = false
            this.modalStore.activeRoutePointModal.lastCompleted = false
        }
    }
}
</script>

<style scoped lang="scss">
.active-route-point-modal {
    .modal-title {
        display: flex;
        align-items: center;
        padding: 2rem 1rem 0 0;

        .route-status {
            margin-right: 0.5rem;
            width: 0.75rem;
            min-width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
        }
    }

    .route-point-body {
        padding-right: 1rem;

        .button-component {
            font-size: 0.875rem;
            min-height: 2.5rem;
            padding: 0.4rem 0.5rem;
            margin-top: 1rem;
            width: 100%;
        }
    }

    .modal-body {
        padding: 2rem 0 10rem;
        overflow-y: auto;
    }

    .modal-buttons {
        .back-btn {
            width: 100% !important;
        }
    }
}
</style>
